function generatePasswordPart(charset, length = 8) {
    let retVal = "";

    for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }

    return retVal;
}

function shuffle(original) {
    let a = original.split(""),
        n = a.length;

    for(let i = n - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
    }
    return a.join("");
}

function generatePassword() {
    let part_alpha = generatePasswordPart("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ");
    let part_num = generatePasswordPart("0123456789");
    return shuffle(part_alpha + part_num)
}

export default generatePassword;
